import React from "react";
import { Link, useLocation } from "react-router-dom";
import { CONTACT_EMAILS, getPageContactEmail } from "./siteContactConfig";
import fispLogo from "../../assets/logo-iniciales-oscuro.png";
const FOOTER_ADDRESS = "Cerrito 1050 Piso 9, CABA, Argentina";
const FOOTER_PHONE_LABEL = "+54 9 11-2387-9118";
const FOOTER_PHONE_HREF = "https://wa.me/5491123879118";
const SOCIAL_URLS = {
    instagram: "https://www.instagram.com/fispsalud/",
    facebook: "https://www.facebook.com/fispsalud",
    linkedin: "https://www.linkedin.com/company/fisp-org/",
    youtube: "https://www.youtube.com/@fisptv",
    spotify: "https://open.spotify.com/show/5VlWWkUHnHON4PIodMQw79",
    tiktok: "https://www.tiktok.com/@fispsalud",
};
const socialLinks = [
    {
        label: "Instagram",
        href: SOCIAL_URLS.instagram,
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="h-[18px] w-[18px]" aria-hidden="true">
                <rect x="3.5" y="3.5" width="17" height="17" rx="5" />
                <circle cx="12" cy="12" r="4" />
                <circle cx="17.2" cy="6.8" r="0.8" fill="currentColor" stroke="none" />
            </svg>
        ),
    },
    {
        label: "Facebook",
        href: SOCIAL_URLS.facebook,
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="h-5 w-5" aria-hidden="true">
                <path
                    d="M15.2 6.9h-1.4c-1.6 0-2.7 1.1-2.7 2.9v1.4H9.2v2.4h1.9v4.6h2.6v-4.6h2.1l.3-2.4h-2.4V10c0-.6.3-.9.9-.9h1.5V6.9Z"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
    },
    {
        label: "LinkedIn",
        href: SOCIAL_URLS.linkedin,
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="h-[18px] w-[18px]" aria-hidden="true">
                <rect x="3.5" y="3.5" width="17" height="17" rx="4.5" />
                <circle cx="8.1" cy="8.1" r="0.8" fill="currentColor" stroke="none" />
                <path d="M8.1 10.7v5.2" strokeLinecap="round" />
                <path d="M11.4 15.9v-5.2" strokeLinecap="round" />
                <path d="M11.4 12.8c0-1.3.8-2.1 1.9-2.1 1.1 0 1.9.8 1.9 2.1v3.1" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        ),
    },
    {
        label: "YouTube",
        href: SOCIAL_URLS.youtube,
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="h-[18px] w-[18px]" aria-hidden="true">
                <path d="M21 12.2c0 2.7-.3 4.5-.8 5.3-.4.7-1 1.2-1.7 1.4-.8.3-2.9.5-6.5.5s-5.7-.2-6.5-.5c-.7-.2-1.3-.7-1.7-1.4-.5-.8-.8-2.6-.8-5.3s.3-4.5.8-5.3c.4-.7 1-1.2 1.7-1.4.8-.3 2.9-.5 6.5-.5s5.7.2 6.5.5c.7.2 1.3.7 1.7 1.4.5.8.8 2.6.8 5.3Z" />
                <path d="m10 8.8 5.2 3.2-5.2 3.2Z" fill="currentColor" stroke="none" />
            </svg>
        ),
    },
    {
        label: "Spotify",
        href: SOCIAL_URLS.spotify,
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="h-[18px] w-[18px]" aria-hidden="true">
                <circle cx="12" cy="12" r="8.5" />
                <path d="M8 10.3c2.8-1 5.7-.9 8.3.2" strokeLinecap="round" />
                <path d="M8.8 13c2.1-.6 4.3-.5 6.2.2" strokeLinecap="round" />
                <path d="M9.5 15.7c1.5-.4 3.1-.3 4.4.2" strokeLinecap="round" />
            </svg>
        ),
    },
    {
        label: "TikTok",
        href: SOCIAL_URLS.tiktok,
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="h-5 w-5" aria-hidden="true">
                <path d="M14.8 6.3v6.4a3.3 3.3 0 1 1-2.4-3.2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14.8 6.3c.6 1.4 1.7 2.4 3.2 2.8v2.1a5.9 5.9 0 0 1-3.2-1" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        ),
    },
];
const footerColumns = [
    {
        id: "educativo",
        title: "Educativo",
        links: [
            {
                label: "Posgrados",
                to: "/educativo?categoria=posgrado&scroll=catalogo",
            },
            {
                label: "Diplomaturas",
                to: "/educativo?categoria=diplomatura&scroll=catalogo",
            },
            {
                label: "Cursos",
                to: "/educativo?categoria=curso&scroll=catalogo",
            },
            {
                label: "FISP + UBA",
                to: "/fisp-uba",
            },
        ],
    },
    {
        id: "tv",
        title: "FISP TV",
        links: [
            {
                label: "Inicio",
                to: "/fisp-tv",
            },
            {
                label: "Segmentos",
                to: "/fisp-tv/segmentos",
            },
            {
                label: "YouTube",
                href: SOCIAL_URLS.youtube,
            },
            {
                id: "tv-empty",
                label: "",
                placeholder: true,
            },
        ],
    },
    {
        id: "servicios",
        title: "Servicios",
        className: "min-[1400px]:min-w-[230px]",
        links: [
            {
                label: "Wellness Corporativo",
                to: "/servicios/wellness-corporativo",
            },
            {
                label: "Proyectos Tecnológicos en Salud",
                to: "/servicios/proyectos-tecnologicos",
            },
            {
                label: "Marketing y Publicidad en Salud",
                to: "/servicios/marketing-publicidad",
            },
            {
                label: "Servicios Médicos",
                to: "/servicios/servicios-medicos",
            },
            {
                label: "Producción y Cobertura de Eventos",
                to: "/servicios/produccion-eventos",
            },
            {
                label: "Capacitación Laboral",
                to: "/servicios/capacitacion-laboral",
            },
        ],
    },
    {
        id: "institucional",
        title: "Institucional",
        links: [
            {
                label: "Inicio",
                to: "/",
            },
            {
                label: "La Fundación",
                to: "/fundacion",
            },
            {
                label: "Contacto",
                to: "/contacto",
            },
            {
                label: "Términos & Condiciones",
                to: "/terminos-y-condiciones",
            },
        ],
    },
];
function getFooterColumns() {
    return footerColumns;
}
function FooterLink({ link }) {
    if (link.placeholder) {
        return <span aria-hidden="true" className="block h-[24px]"></span>;
    }
    if (link.to) {
        return <Link to={link.to}>{link.label}</Link>;
    }
    return <a href={link.href}>{link.label}</a>;
}
function SocialIconLink({ social }) {
    return (
        <a
            href={social.href}
            aria-label={social.label}
            className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-white/70 transition-all duration-200 hover:-translate-y-px hover:bg-white/[0.08] hover:text-white lg:h-9 lg:w-9 xl:h-10 xl:w-10"
        >
            {social.icon}
        </a>
    );
}
export default function SiteFooter({ variant = "default", contactEmail = null, theme = null }) {
    const location = useLocation();
    const resolvedContactEmail =
        contactEmail ||
        (location.pathname.startsWith("/fisp-tv")
            ? CONTACT_EMAILS.servicios
            : getPageContactEmail(location.pathname));
    const columns = getFooterColumns(variant, resolvedContactEmail);
    const brandTarget = variant === "tv" || location.pathname.startsWith("/fisp-tv") ? "/fisp-tv" : "/";
    const footerStyle = {
        "--site-footer-bg": theme?.background || "var(--site-navy-dark)",
    };
    return (
        <footer className="site-footer bg-[var(--site-footer-bg)] text-white" style={footerStyle}>
            <div className="mx-auto max-w-[1280px] px-4 py-14 sm:px-6 lg:px-10">
                <div className="flex flex-col gap-10 lg:w-full lg:flex-row lg:items-start lg:justify-between lg:gap-x-[56px] lg:gap-y-8 xl:gap-x-[84px] xl:gap-y-10">
                    <div className="space-y-4 lg:shrink-0 lg:space-y-3.5 xl:space-y-4">
                        <Link to={brandTarget} className="flex items-center gap-3.5">
                            <img src={fispLogo} alt="FISP" className="h-11 w-auto shrink-0 brightness-0 invert lg:h-10 xl:h-11" />
                            <span className="max-w-[150px] text-[9px] font-semibold uppercase tracking-[0.16em] text-white/65 lg:max-w-[136px] lg:text-[8px] xl:max-w-[150px] xl:text-[9px]">
                                Fundación Iberoamericana de Salud Pública
                            </span>
                        </Link>
                        <div className="space-y-1.5 text-[13px] leading-6 text-white/58 lg:text-[12px] lg:leading-5 xl:text-[13px] xl:leading-6">
                            <p>{FOOTER_ADDRESS}</p>
                            <a href={`mailto:${resolvedContactEmail}`} className="block transition-colors duration-200 hover:text-white/82">
                                {resolvedContactEmail}
                            </a>
                            <a href={FOOTER_PHONE_HREF} className="block transition-colors duration-200 hover:text-white/82">
                                {FOOTER_PHONE_LABEL}
                            </a>
                        </div>
                        <div className="-ml-3 flex flex-nowrap items-center gap-1 pt-0.5">
                            {socialLinks.map((social) => (
                                <SocialIconLink key={social.label} social={social} />
                            ))}
                        </div>
                    </div>

                    <div className="flex flex-col gap-10 min-[750px]:mx-auto min-[750px]:grid min-[750px]:max-w-[860px] min-[750px]:grid-cols-2 min-[750px]:gap-x-[56px] min-[750px]:gap-y-8 min-[1400px]:mx-0 min-[1400px]:max-w-none min-[1400px]:flex min-[1400px]:flex-row min-[1400px]:items-start min-[1400px]:gap-x-[72px] min-[1400px]:gap-y-0">
                        {columns.map((column) => (
                            <div key={column.id || column.title} className={`lg:shrink-0 ${column.className || ""}`}>
                                <h4 className="mb-4 text-[11px] font-bold uppercase tracking-[0.18em] text-white/45 lg:mb-3 lg:text-[10px] xl:mb-4 xl:text-[11px]">
                                    {column.title}
                                </h4>
                                <ul className="space-y-3 lg:space-y-2.5 xl:space-y-3">
                                    {column.links.map((link) => (
                                        <li key={link.id || link.label || `${column.id}-empty`} className="text-[14px] leading-6 text-white/72 lg:text-[13px] lg:leading-5 xl:text-[14px] xl:leading-6">
                                            <FooterLink link={link} />
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="mt-10 border-t border-white/10 pt-5 text-[12px] text-white/50">
                    <div className="w-full">
                        <p>Copyright 2026 FISP - Fundación Iberoamericana de Salud Pública</p>
                    </div>
                </div>
            </div>
        </footer>
    );
}
